/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/

import 'scss/main.scss';

/*------------------------------------------------------------------
Import Global Scripts (Scripts that are always needed)
------------------------------------------------------------------*/

// import 'javascript/components/header';
// import 'javascript/components/mobile-menu';
// import 'javascript/components/mega-menu';
import 'javascript/components/external-links';
import 'javascript/components/back-links';
import 'javascript/components/back-to-top';
import 'javascript/components/linking-mode';
import 'javascript/components/equalizer';

/*------------------------------------------------------------------
Add scripts to the Script Loader object below
------------------------------------------------------------------*/

function loadScripts() {
  window.ScriptsLoaded = ScriptLoader({
    '.js-header': function jsHeader() {
      return import('javascript/components/header');
    },
    '.js-mobile-menu': function jsMobileMenu() {
      return import('javascript/components/mobile-menu');
    },
    '.js-mega-menu': function jsMegaMenu() {
      return import('javascript/components/mega-menu');
    },
    'a[id]:not([href])': function aIdNotHref() {
      return import('javascript/components/anchors');
    },
    '.js-slider': function jsSlider() {
      return import('javascript/components/slider');
    },
    '.js-sidebar': function jsSidebar() {
      return import('javascript/components/sidebar');
    },
    '.js-accordion-grid': function jsAccordionGrid() {
      return import('javascript/components/accordion-grid');
    },
    '.js-simple-selector': function jsSimpleSelector() {
      return import('javascript/components/simple-selector');
    },
    '#breadcrumbs-select': function breadcrumbsSelect() {
      return import('javascript/components/breadcrumbs');
    },
    '#locations-filter': function locationsFilter() {
      return import('javascript/components/locations-filter');
    },
    '.js-search-page, .js-search-modal': function jsSearchPage_JsSearchModal() {
      return import('javascript/search/index');
    },
    '.js-selector': function jsSelector() {
      return import('javascript/pages/facilitators');
    },
    '.js-resources-hub': function jsResourcesHub() {
      return import('javascript/pages/resources-hub');
    }
  });
}
;
function init() {
  loadScripts();
}

// Initialize the element watchers when the document is ready
document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();